import React from 'react';
import { Col, Container, Row, Accordion } from 'react-bootstrap';
import { map, times } from 'lodash';
import { useTranslation } from 'react-i18next';

const FrequentlyAskedQuestionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <h2 className="text-center">{t('cancerInsurancePage.frequentlyAskedQuestionSection.title')}</h2>
      <Container>
        <Row>
          <Col lg={10} className="mx-auto">
            <Accordion flush>
              {map(times(5), (idx) => (
                <Accordion.Item
                  eventKey={t(`cancerInsurancePage.frequentlyAskedQuestionSection.q${idx + 1}`)}
                  key={`fqa${idx + 1}`}
                >
                  <Accordion.Header>
                    <span className="fw-bold">
                      {t(`cancerInsurancePage.frequentlyAskedQuestionSection.q${idx + 1}`)}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ whiteSpace: 'pre-line' }}>
                    {t(`cancerInsurancePage.frequentlyAskedQuestionSection.a${idx + 1}`)}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { FrequentlyAskedQuestionSection };
